import Loadable from 'react-loadable';

import { LoadingPage, LayoutLoadingPage } from 'src/components/react-loadable';
import { loadGlobalResource } from 'src/redux/global/resources/load-global';
import { accountNavigationResource } from 'src/sections/account/account-navigation-resource';
import { GPGKeysResourceLoadable } from 'src/sections/account/sections/settings/components/gpg-keys';
import { SSHKeysResourceLoadable } from 'src/sections/account/sections/settings/components/ssh-keys';

import { ROUTE_NAME, Route, RouteContext } from './types';

const AccountSettingsLayout = Loadable({
  loading: LayoutLoadingPage,
  loader: () => import('src/sections/account/settings-layout'),
});

const AccountSettingsIframe = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/workspace/sections/settings/containers/iframe-wrapped'
    ),
});

const AccountSideNavigationLoadable = Loadable<{}, never>({
  loading: LoadingPage,
  loader: () => import('src/app/nav-system/side-nav/account-admin'),
});

const resources = [loadGlobalResource, accountNavigationResource];

export const accountRoutes: Route[] = [
  {
    name: ROUTE_NAME.ACCOUNT_SETTINGS_GPG_KEYS,
    path: '/account/settings/gpg-keys/',
    exact: true,
    component: GPGKeysResourceLoadable,
    layout: AccountSettingsLayout,
    sideNavigation: AccountSideNavigationLoadable,
    resources,
  },
  {
    name: ROUTE_NAME.ACCOUNT_SETTINGS_SSH_KEYS,
    path: '/account/settings/ssh-keys/',
    exact: true,
    component: SSHKeysResourceLoadable,
    layout: AccountSettingsLayout,
    sideNavigation: AccountSideNavigationLoadable,
    resources,
  },
  // This route is meant to handle both the root "account/settings/" path as
  // well as any other iframe-based settings pages, e.g.
  // "account/settings/app-authorizations/"
  {
    name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
    path: '/account/settings/',
    component: AccountSettingsIframe,
    layout: AccountSettingsLayout,
    sideNavigation: AccountSideNavigationLoadable,
    resources,
  },
];
